import React from 'react';
import { withApollo } from 'react-apollo';
import PropTypes, { object, bool, string } from 'prop-types';
import { xorBy, get, size, find, flatten, isArray, isNil, filter, first, isEqual, isInteger, split } from 'lodash';
import withReloadable from 'app-hocs/withReloadable';
import { ClickOutside } from 'app-components/utils';
import { GET_PICKERS } from '../../../graphql/getPickers';
import { getUserStatus } from '../../../../utils/misc';
import SelectDisplay from './SelectDisplay';

const SelectContext = React.createContext([]);

class SelectController extends React.Component {
  constructor (props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.state = {
      filterBy: '',
      selected: [],
      options: null,
      opened: false,
      allSelected: false,
      idSettimeout: '',
      loadingFilterUser: false
    };
  }

  componentDidMount () {
    const { options, defaultValue, allSelected } = this.props;
    if (allSelected) {
      this._toggleSelectAll();
    }
    if (defaultValue || defaultValue === 0) {
      const initialSelectedOptions = (options || []).filter(({ value, label }) =>
        find(isArray(defaultValue) ? defaultValue : [defaultValue],
          (dvalue, dkey) => (String(value) === get(dvalue, 'value', dvalue) || String(label) === get(dvalue, 'label', dvalue)))
      );
      size(initialSelectedOptions) && this.onSelect(initialSelectedOptions, true, true);
    }
  }

  onSelect = (item, shouldClose, omitValue) => {
    const { multiple, value, activateOptionAll, onChangeSelectAll } = this.props;
    const { label } = item;
    const selected = value;
    const selection = omitValue ? item : flatten(xorBy([item], flatten([selected || []]), 'value'));

    if (activateOptionAll) {
      const onlySelection = omitValue ? item : isEqual([item], selected) ? [] : [item];
      this.setState({
        selected: onlySelection,
        filterBy: size(onlySelection) ? label : '',
        opened: !shouldClose
      }, () => {
        this._notifyParentOnchange(onlySelection);
        !omitValue && onChangeSelectAll({ value: false });
      });
    } else {
      this.setState({
        selected: selection,
        filterBy: '',
        opened: shouldClose ? false : multiple
      }, () => this._notifyParentOnchange(multiple ? selection : first(selection) || {}));
    }
  }

  _notifyParentOnchange = (payload) => {
    const { onChange } = this.props;
    onChange({ value: payload });
  }

  onRemove = (clickedItem, cb) => {
    const { multiple, value } = this.props;
    const newSelection = (value || []).filter((item) => get(item, 'value') !== get(clickedItem, 'value'));
    this.setState({ selected: newSelection },
      () => this._notifyParentOnchange(multiple ? newSelection : first(newSelection) || {}));
  }

  _resolveUserName = (data) => ({
    label: `${get(data, 'firstName', '-')} ${get(data, 'lastName', '-')} - ${get(data, 'email')} - ${get(getUserStatus(), `${get(data, 'status')}.value`, 'Desconectado')}`,
    value: get(data, 'id')
  })

  handleUserSelect = (value) => {
    const { client, salesChannelId } = this.props;
    const filterSalesChannel = salesChannelId ? {
      field: 'salesChannelInfo.salesChannelId',
      value: salesChannelId
    } : {};

    const filterStatusUser = { field: 'statusUser', value: ['0'] };

    if (size(value) >= 3) {
      const filterOrInputSearch = size(split(value, ' ')) >= 2 ? {
        name: split(value, ' ')[0],
        lastName: split(value, ' ')[1]
      } : { name: value, lastName: value, email: value };

      clearTimeout(this.state.idSettimeout);
      this.setState({ idSettimeout: setTimeout(() => {
        this.setState({ loadingFilterUser: true });
        client.query({
          query: GET_PICKERS,
          variables: { filters: [ filterSalesChannel, filterStatusUser ], or: filterOrInputSearch },
          fetchPolicy: 'network-only'
        })
          .then(({ data }) => {
              this.setState({ options: [] });
              const response = get(data, 'getUsersFeed.results', []);
              const newOptions = response.map((item) => this._resolveUserName(item));
              this.setState({ options: newOptions }, () => this.setState({ loadingFilterUser: false }));
          });
      }, 500)
      });
    }
  }

  // autocomplete handler
  onFilterChange = (value) => {
    const { fromUserSelect } = this.props;
    this.setState({ filterBy: value });
    // autocomplete handler user select
    fromUserSelect && this.handleUserSelect(value);
  }

  isSelected = (index) => {
    const selection = this._getSelectedList().map(({ value }) => String(value));
    return selection.includes(String(index));
  }

  _openOptionsList = () =>
    this.setState({ opened: !this.state.opened });

  _filterOptions = () => {
    const { options, fromUserSelect } = this.props;
    const { filterBy } = this.state;
    // if (has(value, 'value')) return options
    const fromOptions = fromUserSelect ? this.state.options : options;

    const filteredOptions = !fromUserSelect ? fromOptions.filter(
      ({ value, label }) =>
        (isInteger(!value) && value.toLowerCase().indexOf(String(filterBy).toLowerCase()) > -1) ||
        label.toLowerCase().indexOf(String(filterBy).toLowerCase()) > -1
    ) : fromOptions;

    return size(filteredOptions) ? filteredOptions : [];
  }

  _getOptionsList = () => {
    const { options, fromUserSelect } = this.props;
    const { filterBy } = this.state;
    // if (allSelected) return options;
    if (size(filterBy) > 0) return this._filterOptions();
    return fromUserSelect ? this.state.options : options;
  }
  _getSelectedList = () => {
    const { value = [] } = this.props;
    return filter(flatten([value]), (item) => !isNil(item));
  }

  _toggleSelectAll = (allSelected = this.state.allSelected) => {
    const { onChange, onChangeSelectAll, activateOptionAll } = this.props;
    if (activateOptionAll) {
      this.setState({
        selected: allSelected ? [] : this.props.options,
        filterBy: ''
      }, () => {
        onChange({ value: this.state.selected });
        onChangeSelectAll({ value: true });
      });
    } else {
      this.setState({
        selected: allSelected ? [] : this.props.options
      }, () => onChange({ value: this.state.selected }));
    }
  }

  setOpenedSelect = () =>
    this.setState({ opened: true });

  render () {
    const { multiple, children, label, autoComplete, options, disabled, activateOptionAll, fromUserSelect, salesChannelId } = this.props;
    const { opened, filterBy } = this.state;
    const selected = this._getSelectedList();

    return (
        <ClickOutside onClickOutside={() => opened && this._openOptionsList()}>
            <SelectContext.Provider
                value={{
                  disabled,
                  autoComplete,
                  filterBy,
                  opened,
                  label,
                  activateOptionAll,
                  allSelected: ((multiple || activateOptionAll) && size(options) === size(selected)) && !fromUserSelect,
                  isMultiple: multiple,
                  options: this._getOptionsList(),
                  selected: selected,
                  fromUserSelect,
                  loadingFilterUser: this.state.loadingFilterUser,
                  onSelect: this.onSelect,
                  onFilterChange: this.onFilterChange,
                  toggleOptions: this._openOptionsList,
                  toggleSelectAll: this._toggleSelectAll,
                  onRemove: this.onRemove,
                  isSelected: this.isSelected,
                  setOpenedSelect: this.setOpenedSelect,
                  salesChannelId
                }}
            >
                {children}
            </SelectContext.Provider>
        </ClickOutside>
    );
  }
}

SelectController.propTypes = {
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  autoComplete: PropTypes.bool,
  activateOptionAll: PropTypes.bool,
  allSelected: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array,
  multiple: PropTypes.bool,
  children: PropTypes.any,
  onChange: PropTypes.func,
  onChangeSelectAll: PropTypes.func,
  value: PropTypes.any,
  fromUserSelect: PropTypes.bool,
  client: PropTypes.object,
  salesChannelId: PropTypes.string
};

SelectController.defaultProps = {
  autoComplete: false,
  activateOptionAll: false,
  allSelected: false,
  disabled: false,
  label: 'Seleccionar',
  icon: 'icon',
  multiple: false,
  options: null,
  onChange: (state) => (console.log(state)),
  fromUserSelect: false,
  salesChannelId: PropTypes.string
};

const FormSelect = ({ optionsUp, placeholderAllSelected, position, error, borderColor, ...props }) => {
  const selectDisplayProps = {
    position,
    optionsUp,
    placeholderAllSelected,
    error,
    borderColor
  };
    return <SelectController {...props}>
        <SelectDisplay context={SelectContext} {...selectDisplayProps} />
    </SelectController>;
};

FormSelect.propTypes = {
  optionsUp: bool,
  position: object,
  placeholderAllSelected: bool,
  context: object,
  error: bool,
  borderColor: string
};

export default withApollo(withReloadable(FormSelect, ['value.label', 'allSelected']));
